export class FlexibleCourseEnrolmentRequest {
  studentId: string;
  courseId: string;
  programLevelId: string;
  numberOfWeeks: number;
  acceptedTermsAndConditions: boolean;
  acceptedPolicyIds: string[];
  startDate: Date;
}
